module.exports = __webpack_public_path__ + "static/img/error.7c88c8a2.png";